const siteRedirects = [
    { from: /^\/~hiro\/(.*)$/, to: (_, suffix) => `http://www.ertl.jp/hiro/${suffix}` },
    { from: /^\/~itoh\/(.*)$/, to: (_, suffix) => `http://www.ertl.jp/itoh/${suffix}` },
    { from: /^\/~yutaka\/(.*)$/, to: (_, suffix) => `https://sites.google.com/site/yutakaertl/${suffix}` },
    { from: /^\/~watanabe\/(.*)$/, to: (_, suffix) => `https://sites.google.com/view/yousukewatanabe/${suffix}` },
];

module.exports = { siteRedirects };
